import { render, staticRenderFns } from "./EstadisticaAsistencias.vue?vue&type=template&id=4e18ce85&scoped=true&"
import script from "./EstadisticaAsistencias.vue?vue&type=script&lang=js&"
export * from "./EstadisticaAsistencias.vue?vue&type=script&lang=js&"
import style0 from "./EstadisticaAsistencias.vue?vue&type=style&index=0&id=4e18ce85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18ce85",
  null
  
)

export default component.exports